import { AssetVisitYardEventType } from './asset-visit';

export interface IAssetVisitEvent {
  id: string;
  assetVisitId: string;
  eventType: AssetVisitEventType;
  assetContainerId?: string;
}

export enum AssetVisitEventType {
  NotArrived = 'NotArrived',
  Arrived = 'Arrived',
  Docked = 'Docked',
  Departed = 'Departed',
  Canceled = 'Canceled',
  Attached = 'Attached',
  Detached = 'Detached',
  AppointmentLinked = 'Appointment Linked',
  AppointmentUnlinked = 'Appointment Unlinked'
}

export const AssetVisitEventOrder = [
  AssetVisitEventType.NotArrived,
  AssetVisitEventType.Arrived,
  AssetVisitEventType.Docked,
  AssetVisitEventType.Departed,
  AssetVisitEventType.Canceled
] as const;

export function getYardEventType(
  eventType: AssetVisitEventType
): AssetVisitYardEventType | undefined {
  if (eventType === AssetVisitEventType.Attached) {
    return AssetVisitYardEventType.Hooked;
  } else if (eventType === AssetVisitEventType.Detached) {
    return AssetVisitYardEventType.Dropped;
  }
}
